<template>
  <w-card tile class="fill-width initiative mt3">
    <template #title>
      <w-toolbar>
        <div class="title3">{{ initiative.title }}</div>
        <!--<div class="spacer"></div>
        <a v-bind:href="'https://change.misis.club/article/' + aid">
          <w-button icon="fa fa-arrow-right" text lg class="ml3"></w-button>
        </a> -->
        <div class="spacer"></div>
      </w-toolbar>
    </template>
    <p class="long">
      {{ initiative.long }}
    </p>
    <w-button v-if="!isVoted" class="mt3 mb3" bg-color="success" type="submit" v-on:click="doVote">Поддерживаю</w-button>
    <w-button v-else class="mt3 mb3" bg-color="secondary" type="submit" v-on:click="doRetract">Передумал</w-button>
    <div v-if="initiative.votes.length > 0">
      На текущий момент набрано {{ initiative.votes.length }} из {{ initiative.neededVotes }} необходимых подписей.
      <div class="mt3">
        Список поддержавших:
        <ol>
          <template v-for="vote in initiative.votes" v-bind:key="vote.name">
            <li>{{ vote.name }}</li>
          </template>
        </ol>
      </div>
    </div>
    <div v-else>
      Пока что данную инициативу никто не поддержал, но вы можете стать первым.
    </div>
  </w-card>
</template>

<script>
import {ref} from 'vue';
import {getInitiative, vote, retract} from './util.js';

export default {
  name: 'InitiativeCard',
  props: {
    id: String,
    user: Object
  },
  data() {
    return {
      isVoted: this.vote,
      scoreCopy: this.score
    }
	},
  async setup(props) {
    var initiative = ref(await getInitiative(props.id));
    var vote = ref(false);
    for (var voter of initiative.value.votes) {
      if (voter.email == props.user.email) {
        vote = ref(true);
        break;
      }
    }
    return { initiative, vote }
  },
  methods: {
    sendVote: async function(f){
      if (!this.user.authorized) {
        this.$waveui.notify('Для голосования нужно войти. Сейчас вы будете направлены на страницу авторизации.', 'info');
        setTimeout(() => window.location = 'https://account.misis.club/?return=' + window.location.href, 1500);
        return
      }
      var result = await f(this.initiative.initiativeId);
      if (result) {
        this.$waveui.notify('Ваш голос учтен', 'success');
        this.isVoted = !this.isVoted;
        this.initiative = await getInitiative(this.id);
      }
      else {
        this.$waveui.notify('Произошла непредвиденная ошибка', 'error');
      }
    },
    doVote: async function(){await this.sendVote(vote);},
    doRetract: async function(){await this.sendVote(retract);}
  }
}
</script>

<style>
.initiative {
  max-width: 1000px;
  min-width: 300px;
}
.long {
  white-space: pre-line;
}
ol {
  list-style-position: inside;
}
</style>
